import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { navVisibilityControls, navConfigControls, bookmarksApi } from '../messages';
export const NAVIGATION_PUBLIC_API_TOPIC_NAME = '@@navigation/public-api';
export const navPublicApiAudience = AudienceFilter.builder().excludeSelf();
export const navigationPublicApiTopicDef = defineTopic({
  name: NAVIGATION_PUBLIC_API_TOPIC_NAME,
  messages: [navVisibilityControls.changeNavVisibility, navVisibilityControls.getNavVisibility, navVisibilityControls.navVisibilityChanged, navConfigControls.requestInvalidation, bookmarksApi.addBookmark, bookmarksApi.bookmarkChanged, bookmarksApi.removeBookmark],
  enableRuntimeValidation: false,
  audience: navPublicApiAudience.build()
});